import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../Components/Button/Button'
import { useLocalization } from '../../../Hooks/useLocalization'
import './CertificateInstanceList.scss'
import { setDestinationView } from '../../../Store/InterfaceSlice'
import { TextInput } from '../../../Components/TextInput/TextInput'
import { type RootState } from '../../../Store/Store'
import { useEffect, useMemo, useState } from 'react'
import { TableList } from '../../../Components/TableList/TableList'
import {
  type CertificateInstanceCoordinator,
  setIsCertificateInstancesRequested,
} from '../../../Store/DataSlice'
import { sortResultString } from '../../../Utils/Arrays'

const localizationSection = 'certificate-instance'
export function CertificateInstanceList() {
  const dispatch = useDispatch()
  const localization = useLocalization(localizationSection)
  const user = useSelector((state: RootState) => state.authentication.user)

  const isCertificateInstancesRequested = useSelector(
    (state: RootState) => state.data.isCertificateInstancesRequested
  )
  useEffect(() => {
    if (!isCertificateInstancesRequested)
      dispatch(setIsCertificateInstancesRequested(true))
  }, [isCertificateInstancesRequested, dispatch])

  const allCertificateInstances = useSelector(
    (state: RootState) => state.data.certificateInstances
  )
  const [filterName, setFilterName] = useState('')

  const filteredCertificateInstances = useMemo(() => {
    return allCertificateInstances
      .filter((c) => {
        if (
          filterName &&
          !c.name.toLowerCase().includes(filterName.toLowerCase())
        )
          return false
        return true
      })
      .sort((a, b) => sortResultString(a.name, b.name))
  }, [allCertificateInstances, filterName])

  return (
    <div className="certificate-instances-list">
      {user?.isAdmin ?? false ? (
        <div className="button-row">
          <Button
            importance={'primary'}
            text={localization.text(
              'add-certificate-instance',
              'Voeg certificaat instantie toe'
            )}
            onClick={() =>
              dispatch(
                setDestinationView({
                  destinationView: 'certificate-instance-add',
                })
              )
            }
          />
        </div>
      ) : null}
      <div className="filters">
        <div className="filter-field">
          <TextInput
            label={localization.text('filter-name-input-label', 'Naam')}
            helperText={localization.text(
              'filter-name-input-helper',
              'Geef (een deel van) de naam van de certificaat instantie in'
            )}
            value={filterName}
            onChange={setFilterName}
          />
        </div>
      </div>
      <TableList
        tableType="certificate-instance"
        items={filteredCertificateInstances}
        configurations={{
          vatNumber: {
            label: 'Ondernemings nummer',
            show: false,
          },
          name: {
            label: 'Naam',
            show: true,
          },
          email: {
            label: 'Email',
            show: false,
          },
          website: {
            label: 'Website',
            show: false,
          },
          telephone: {
            label: 'Telefoon',
            show: false,
          },
          addressLine1: {
            label: 'Straat en huisnummer',
            show: true,
          },
          postalCode: {
            label: 'Postcode',
            show: true,
          },
          city: {
            label: 'Gemeente',
            show: true,
          },
          countryCode: {
            label: 'Land',
            show: true,
          },
          coordinators: {
            label: 'Coordinators',
            show: false,
            getValue: (value) =>
              (value as CertificateInstanceCoordinator[])
                .map((c) => c.name)
                .join(', '),
          },
        }}
        localizationSection={localizationSection}
        getUniqueKey={(item) => item.vatNumber}
        onRowClick={(item) =>
          dispatch(
            setDestinationView({
              destinationView: 'certificate-instance-detail',
              detailKey: item.vatNumber,
            })
          )
        }
        isLoading={allCertificateInstances.length === 0}
      />
    </div>
  )
}
